// extracted by mini-css-extract-plugin
export default {"wrapper":"ynVAV","icon":"k8p6J"};